"use client"

import { useState } from "react"
import { Outlet, NavLink } from "react-router-dom"
// Replace LineChart with BarChart2
import { Sun, Battery, Calendar, Home, Settings, BarChart2, Menu } from "react-feather"
import "../styles/Layout.css"

const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true)

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

  return (
    <div className="layout">
      {/* Sidebar */}
      <aside className={`sidebar ${isSidebarOpen ? "open" : "closed"}`}>
        <div className="sidebar-header">
          <div className="logo">
            <Sun className="logo-icon" />
            <span className="logo-text">SolarDash</span>
          </div>
        </div>
        <nav className="sidebar-nav">
          <ul>
            <li>
              <NavLink to="/" className={({ isActive }) => (isActive ? "active" : "")} end>
                <Home size={18} />
                <span>Dashboard</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/analytics" className={({ isActive }) => (isActive ? "active" : "")}>
                <BarChart2 size={18} />
                <span>Analytics</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/storage" className={({ isActive }) => (isActive ? "active" : "")}>
                <Battery size={18} />
                <span>Storage</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/schedule" className={({ isActive }) => (isActive ? "active" : "")}>
                <Calendar size={18} />
                <span>Schedule</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/settings" className={({ isActive }) => (isActive ? "active" : "")}>
                <Settings size={18} />
                <span>Settings</span>
              </NavLink>
            </li>
          </ul>
        </nav>
        <div className="sidebar-footer">
          <div className="plant-status">
            <div className="plant-icon">
              <Sun size={20} />
            </div>
            <div className="plant-info">
              <p className="plant-name">Solar Plant #1</p>
              <p className="plant-status-text">Online</p>
            </div>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="main-content">
        <header className="main-header">
          <button className="sidebar-toggle" onClick={toggleSidebar} aria-label="Toggle Sidebar">
            <Menu size={20} />
          </button>
          <div className="header-actions">
            <select className="plant-selector">
              <option>Solar Plant #1</option>
              <option>Solar Plant #2</option>
              <option>Solar Plant #3</option>
            </select>
          </div>
        </header>

        <div className="page-content">
          <Outlet />
        </div>
      </main>
    </div>
  )
}

export default Layout
